import React from "react";
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
import { useTranslation } from "@/translations/TranslationContext";
import "@/components/Services/Services.css";
import imgMonthlyBookkeeping from "@/assets/MonthlyBookkeeping.png";
import iconkey1 from "@/assets/icon_key1.png";
import iconkey2 from "@/assets/icon_key2.png";
import iconkey3 from "@/assets/icon_key3.png";

const TaxPreparation = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <Header />
      <div className="banner innerbanner banservices_tp">
        <div className="container">
          <div className="inerban">
            <span className="chips">{t.taxPreparation.banner.chips}</span>
            <h1>{t.taxPreparation.banner.title}</h1>
            <p className="text24">
              {t.taxPreparation.banner.subtitle}
            </p>
            <a className="btn btnbanner" href="/contact">
              {t.taxPreparation.banner.button}
            </a>
          </div>
        </div>
      </div>

      <div className="container mb150_75 whatincluded">
        <div className="row">
          <div className="col-lg-6">
            <span className="chips">{t.taxPreparation.included.chips}</span>
            <h2>{t.taxPreparation.included.title}</h2>
            <p className="text24">
              {t.taxPreparation.included.subtitle}
            </p>
            <div className="accordion" id="whatincludedaccordion">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded1"
                    aria-expanded="false"
                    aria-controls="whatincluded1"
                  >
                    {t.taxPreparation.included.sections.returns.title}
                  </button>
                </h2>
                <div
                  id="whatincluded1"
                  className="accordion-collapse collapse"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.taxPreparation.included.sections.returns.description}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded2"
                    aria-expanded="false"
                    aria-controls="whatincluded2"
                  >
                    {t.taxPreparation.included.sections.optimization.title}
                  </button>
                </h2>
                <div
                  id="whatincluded2"
                  className="accordion-collapse collapse"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.taxPreparation.included.sections.optimization.description}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded3"
                    aria-expanded="false"
                    aria-controls="whatincluded3"
                  >
                    {t.taxPreparation.included.sections.support.title}
                  </button>
                </h2>
                <div
                  id="whatincluded3"
                  className="accordion-collapse collapse"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.taxPreparation.included.sections.support.description}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded4"
                    aria-expanded="true"
                    aria-controls="whatincluded4"
                  >
                    {t.taxPreparation.included.sections.documentation.title}
                  </button>
                </h2>
                <div
                  id="whatincluded4"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.taxPreparation.included.sections.documentation.description}
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#whatincluded5"
                    aria-expanded="false"
                    aria-controls="whatincluded5"
                  >
                    {t.taxPreparation.included.sections.financialStatements.title}
                  </button>
                </h2>
                <div
                  id="whatincluded5"
                  className="accordion-collapse collapse"
                  data-bs-parent="#whatincludedaccordion"
                >
                  <div className="accordion-body">
                    {t.taxPreparation.included.sections.financialStatements.description}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <img
              className="mobmt30"
              src={imgMonthlyBookkeeping}
              alt="imgMonthlyBookkeeping"
            />
          </div>
        </div>
      </div>

      <div className="key_benefits mb150_75">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 keybenfttext">
              <span className="chips">{t.taxPreparation.benefits.chips}</span>
              <h2>{t.taxPreparation.benefits.title}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <div className="keybenftbox keybenftboxactive">
                <img src={iconkey1} alt="iconkey1" />
                <h4>{t.taxPreparation.benefits.sections.refunds.title}</h4>
                <p>
                  {t.taxPreparation.benefits.sections.refunds.description}
                </p>
                <a className="btn" href="/contact">
                  {t.taxPreparation.benefits.button}
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="keybenftbox">
                <img src={iconkey2} alt="iconkey2" />
                <h4>{t.taxPreparation.benefits.sections.mistakes.title}</h4>
                <p>
                  {t.taxPreparation.benefits.sections.mistakes.description}
                </p>
                <a className="btn" href="/contact">
                  {t.taxPreparation.benefits.button}
                </a>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="keybenftbox">
                <img src={iconkey3} alt="iconkey3" />
                <h4>{t.taxPreparation.benefits.sections.peace.title}</h4>
                <p>
                  {t.taxPreparation.benefits.sections.peace.description}
                </p>
                <a className="btn" href="/contact">
                  {t.taxPreparation.benefits.button}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mb150_75 faqs">
        <div className="faqstext">
          <span className="chips">{t.taxPreparation.faq.chips}</span>
          <h2>{t.taxPreparation.faq.title}</h2>
        </div>
        <div className="accordion" id="faqsaccordion">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {t.taxPreparation.faq.questions.behind.question}
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              data-bs-parent="#faqsaccordion"
            >
              <div className="accordion-body">
                {t.taxPreparation.faq.questions.behind.answer}
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                {t.taxPreparation.faq.questions.selfEmployed.question}
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              data-bs-parent="#faqsaccordion"
            >
              <div className="accordion-body">
                {t.taxPreparation.faq.questions.selfEmployed.answer}
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                {t.taxPreparation.faq.questions.documents.question}
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              data-bs-parent="#faqsaccordion"
            >
              <div className="accordion-body">
                {t.taxPreparation.faq.questions.documents.answer}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default TaxPreparation;
